var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section"},[_c('h2'),_c('User',{scopedSlots:_vm._u([{key:"user",fn:function(ref){
var user = ref.user;
return [(user)?_c('div',[_c('h3',[_vm._v("User Profile ")]),_c('UserProfile',{attrs:{"user":user}}),_c('h3',[_vm._v("My chat rooms")]),_c('ChatList',{attrs:{"uid":user.uid}})],1):_c('Login')]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }